import React from 'react';
import {
    Input,
    Button,
    Form,
    Switch,
    Radio
   } from "antd";
  import { useEffect, useState } from "react";
  import { useNavigate, useParams } from "react-router-dom";
  import * as Validation from "../../../../utils/helper/validation";
  import * as Apis from "../../../../utils/helper/enum";
  import globalRequest from "../../../../utils/global/globalRequest";
  import { changeLoader } from "../../../../redux/reducers/loader";
  import { useDispatch } from "react-redux";
  import toast from "react-hot-toast";


function Index({ walletToggle, setWalletToggle, setDefaultIndex }) {

    const navigate = useNavigate();
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [deliveryFeeType, setDeliveryFeeType] = useState("no_flat_cap");
    const [couponToggle, setCouponToggle] = useState(true);
    let { id } = useParams();

    const getAmountLabel = () => {
      if (deliveryFeeType === "dynamic_flat_cap") {
        return "Delivery Flat Cap Fees";
      }
      if (deliveryFeeType === "fixed_delivery_vendor") {
        return "Fixed Delivery Fees Paid by the Vendor";
      }
      if (deliveryFeeType === "fixed_delivery_customer") {
        return "Fixed Delivery Fees Paid by the Customer";
      }
      return "Delivery Fees";
    };

      const handleInputChange = (name) => {
        form.setFields([
          {
            name,
            errors: [],
          },
        ]);
      };

      const handleSubmit = async (values, isAutoSubmit = false) => {
        const autoSubmit = typeof isAutoSubmit === 'boolean' ? isAutoSubmit : false;
        const couponAmount = values?.couponAmount !== undefined 
          ? values.couponAmount 
          : (deliveryFeeType && deliveryFeeType !== "no_flat_cap" ? form.getFieldValue("couponAmount") : null);
        
        // Determine walletTopup: use passed value or current state
        const walletTopup = values?.walletTopup !== undefined 
          ? values.walletTopup 
          : walletToggle
        dispatch(changeLoader(true));
        try {
          let url = Apis?.MANAGE_VENDOR?.VENDOR_SETTINGS;
          let method = "put";
          let params = {
            vendor_id: id,
            walletTopup: walletTopup,
            couponToggle:couponToggle,
            couponAmount: deliveryFeeType === "dynamic_flat_cap" ? couponAmount : null,
            fixedFlatCapByVendor: deliveryFeeType === "fixed_delivery_vendor" ? couponAmount : null,
            fixedFlatCapByCustomer: deliveryFeeType === "fixed_delivery_customer" ? couponAmount : null,
          };
       
          let response = await globalRequest(url, method, {params:params}, {}, true);
          let apiResponse = response?.data;
          if (response?.status === 200) {
            let msg = "Settings updated successfully";
            // if (id) msg = "Vendor updated successfully";
            toast.success(msg, {
              duration: 2000,
            });
            if (!autoSubmit) {
              if (setDefaultIndex) {
                setDefaultIndex("1");
              } else {
                navigate("/manage-vendor");
              }
            }
          } else {
            toast.error(apiResponse?.message);
          }
        } catch (e) {
          toast.error(e?.message);
        }
        dispatch(changeLoader(false));
      };
    
  const getVendorDetail = async (id) => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_VENDOR.GET_VENDOR_DETAIL + "/" + id,
        "get",
        {},
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let data = apiResponse?.data;
        const settings = data?.vendorDetail?.settings || {};
        const isWalletTopupEnabled = settings.walletToggle ? true : false;
        
        if (settings.couponAmount) {
          setDeliveryFeeType("dynamic_flat_cap");
          form.setFieldValue("couponAmount", settings.couponAmount);
        } else if (settings.fixedFlatCapByVendor) {
          setDeliveryFeeType("fixed_delivery_vendor");
          form.setFieldValue("couponAmount", settings.fixedFlatCapByVendor);
        } else if (settings.fixedFlatCapByCustomer) {
          setDeliveryFeeType("fixed_delivery_customer");
          form.setFieldValue("couponAmount", settings.fixedFlatCapByCustomer);
        } else {
          setDeliveryFeeType("no_flat_cap");
          form.setFieldValue("couponAmount", null);
        }

        if (isWalletTopupEnabled) {
          setWalletToggle(true);
          form.setFieldValue("walletToggle", isWalletTopupEnabled);
        } else {
          setWalletToggle(false);
          form.setFieldValue("walletToggle", false);
        }

        const isCouponEnabled = (settings.couponToggle === null || settings.couponToggle === undefined) ? true : settings.couponToggle;
        setCouponToggle(isCouponEnabled);
        form.setFieldValue("couponToggle", isCouponEnabled);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  useEffect(() => {
    if (id) getVendorDetail(id);
  }, []);

      
  return (
    <>
      <div className="mb-0 flex justify-between flex-wrap w-[30%]">
        <Form.Item label="Enable Wallet">
          <Switch
            checked={walletToggle}
            onChange={(checked) => {
              setWalletToggle(checked);
            }}
          />
        </Form.Item>
         <Form.Item label="Enable Coupon/Discount">
          <Switch
            checked={couponToggle}
            onChange={(checked) => {
              setCouponToggle(checked);
            }}
          />
        </Form.Item>
        <Form.Item label="Delivery Fee Settings">
          <Radio.Group
            value={deliveryFeeType}
            onChange={(e) => {
              const val = e.target.value;
              setDeliveryFeeType(val);
              if (val === "no_flat_cap") {
                form.resetFields(["couponAmount"]);
              }
            }}
          >
            <div className="flex flex-col gap-2">
              <Radio 
                value="no_flat_cap"
              >
                No Flat Cap
              </Radio>
              <Radio 
                value="dynamic_flat_cap"
                onClick={() => {
                  if (deliveryFeeType === "dynamic_flat_cap") {
                    setDeliveryFeeType("no_flat_cap");
                    form.resetFields(["couponAmount"]);
                  }
                }}
              >
                Dynamic Flat Cap Paid by the customer
              </Radio>
              <Radio 
                value="fixed_delivery_vendor"
                onClick={() => {
                  if (deliveryFeeType === "fixed_delivery_vendor") {
                    setDeliveryFeeType("no_flat_cap");
                    form.resetFields(["couponAmount"]);
                  }
                }}
              >
                Fixed Delivery fees paid by the vendor
              </Radio>
              <Radio 
                value="fixed_delivery_customer"
                onClick={() => {
                  if (deliveryFeeType === "fixed_delivery_customer") {
                    setDeliveryFeeType("no_flat_cap");
                    form.resetFields(["couponAmount"]);
                  }
                }}
              >
                Fixed Delivery fees paid by the customer
              </Radio>
            </div>
          </Radio.Group>
        </Form.Item>

        {/* {couponToggle && ( */}
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
        >
          {deliveryFeeType && deliveryFeeType !== "no_flat_cap" && (
            <Form.Item
              label={getAmountLabel()}
              name="couponAmount"
              rules={[
                {
                  required: true,
                  message: "Please enter Amount",
                },
              ]}
            >
              <Input
                size="Large"
                maxLength={10}
                addonAfter="SAR"
                onChange={(e) => {
                  let value = Validation.strFormat(e.target.value, "number");
                  form.setFieldValue("couponAmount", value.trimStart());
                  handleInputChange("couponAmount");
                }}
              />
            </Form.Item>
            )}
            <div className="flex justify-end gap-3">
              <Button onClick={() => navigate("/manage-vendor")}>Cancel</Button>
              <Button type="primary" htmlType="submit">Submit</Button>
            </div>
        </Form>
        {/* )} */}
      </div>
    </>
  );
}

export default Index;
